import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(ICU)
  .init({
    partialBundledLanguages: true,
    load: 'currentOnly',
    supportedLngs: ['pt-BR', 'en-US'],
    fallbackLng: 'pt-BR',

    // backend
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // @ts-ignore
      queryStringParams: typeof window !== 'undefined' ? { v: window.__DASHBOARD_MONOREPO_VERSION__ as string } : undefined,
    },
    // Language mapping to handle browser language codes
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'cobli-language',
    },
    react: {
      bindI18n: 'languageChanged loaded',
      nsMode: 'default',
      bindI18nStore: 'added removed',
    },
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    ns: [
      'common',
      'app-header',
      'login',
      'monitoring',
      'media',
      'drivers',
      'devices',
      'vehicles',
      'reports',
      'maintenance',
      'home',
      'account',
      'routing',
      'tracking',
      'safety',
      'checklists',
      'costs',
      'expenses',
      'fuel',
      'advanced-analytics',
      'business-manager',
      'crm',
      'device-configuration',
      'economic-driving',
      'expenses',
      'geofences',
      'global-search',
      'groups',
      'hooks',
      'insights',
      'livestream',
      'path-association',
      'proof-of-conclusion',
      'road-speed',
      'safety-dashboard',
      'safety-ranking',
      'fuel-card',
      'business-manager',
      'store',
      'training',
      'ui-business',
      'integrations',
    ],
    keySeparator: '.',
    nsSeparator: ':',
    appendNamespaceToMissingKey: true,
    resources: {},
  });

export default i18n;
